export type LyceoSubjectName = string;

export interface LyceoSubjectIcon {
  name: LyceoSubjectName;
  file?: string;
  cssVarDark: string;
  cssVarLight: string;
  bottomOffset: number;
}

export const lyceoSubjectIcons: LyceoSubjectIcon[] = [
  {
    name: 'Aardrijkskunde',
    file: 'AK.svg',
    cssVarDark: 'color-subject-ak-dark',
    cssVarLight: 'color-subject-ak-light',
    bottomOffset: 19,
  },
  {
    name: 'Bedrijfseconomie',
    file: 'BE.svg',
    cssVarDark: 'color-subject-be-dark',
    cssVarLight: 'color-subject-be-light',
    bottomOffset: 24,
  },
  {
    name: 'Biologie',
    file: 'BI.svg',
    cssVarDark: 'color-subject-bi-dark',
    cssVarLight: 'color-subject-bi-light',
    bottomOffset: 11,
  },
  {
    name: 'Duits',
    file: 'DU.svg',
    cssVarDark: 'color-subject-du-dark',
    cssVarLight: 'color-subject-du-light',
    bottomOffset: 23,
  },
  {
    name: 'Economie',
    file: 'EC.svg',
    cssVarDark: 'color-subject-ec-dark',
    cssVarLight: 'color-subject-ec-light',
    bottomOffset: 13,
  },
  {
    name: 'Engels',
    file: 'EN.svg',
    cssVarDark: 'color-subject-en-dark',
    cssVarLight: 'color-subject-en-light',
    bottomOffset: 15,
  },
  {
    name: 'Frans',
    file: 'FR.svg',
    cssVarDark: 'color-subject-fr-dark',
    cssVarLight: 'color-subject-fr-light',
    bottomOffset: 15,
  },
  {
    name: 'Geschiedenis',
    file: 'GE.svg',
    cssVarDark: 'color-subject-ge-dark',
    cssVarLight: 'color-subject-ge-light',
    bottomOffset: 19,
  },
  {
    name: 'Grieks',
    file: 'GR.svg',
    cssVarDark: 'color-subject-gr-dark',
    cssVarLight: 'color-subject-gr-light',
    bottomOffset: 23,
  },
  {
    name: 'Latijn',
    file: 'LA.svg',
    cssVarDark: 'color-subject-la-dark',
    cssVarLight: 'color-subject-la-light',
    bottomOffset: 14,
  },
  {
    name: 'Lyceo Opstap PO Rekenen',
    file: 'opstap-po-rekenen.svg',
    cssVarDark: 'color-subject-opstap-dark',
    cssVarLight: 'color-subject-opstap-light',
    bottomOffset: 18,
  },
  {
    name: 'Natuur- en scheikunde 1',
    file: 'nask1.svg',
    cssVarDark: 'color-subject-nask1-dark',
    cssVarLight: 'color-subject-nask1-light',
    bottomOffset: 20,
  },
  {
    name: 'Natuur- en scheikunde 2',
    file: 'nask2.svg',
    cssVarDark: 'color-subject-nask2-dark',
    cssVarLight: 'color-subject-nask2-light',
    bottomOffset: 20,
  },
  {
    name: 'Natuur- en scheikunde',
    file: 'NA.svg',
    cssVarDark: 'color-subject-na-dark',
    cssVarLight: 'color-subject-na-light',
    bottomOffset: 19,
  },
  {
    name: 'Natuurkunde',
    file: 'NA.svg',
    cssVarDark: 'color-subject-na-dark',
    cssVarLight: 'color-subject-na-light',
    bottomOffset: 19,
  },
  {
    name: 'Nederlands',
    file: 'NL.svg',
    cssVarDark: 'color-subject-nl-dark',
    cssVarLight: 'color-subject-nl-light',
    bottomOffset: 15,
  },
  {
    name: 'Scheikunde',
    file: 'SK.svg',
    cssVarDark: 'color-subject-sk-dark',
    cssVarLight: 'color-subject-sk-light',
    bottomOffset: 20,
  },

  {
    name: '[KB] Huiswerkbegeleiding',
    file: 'WI.svg',
    cssVarDark: 'color-subject-wi-dark',
    cssVarLight: 'color-subject-wi-light',
    bottomOffset: 15,
  },
  {
    name: 'KB Module overzicht',
    file: 'WI.svg',
    cssVarDark: 'color-subject-wi-dark',
    cssVarLight: 'color-subject-wi-light',
    bottomOffset: 15,
  },
  {
    name: 'Wiskunde A',
    file: 'WA.svg',
    cssVarDark: 'color-subject-wa-dark',
    cssVarLight: 'color-subject-wa-light',
    bottomOffset: 18,
  },
  {
    name: 'Wiskunde B',
    file: 'WB.svg',
    cssVarDark: 'color-subject-wb-dark',
    cssVarLight: 'color-subject-wb-light',
    bottomOffset: 19,
  },
  {
    name: 'Wiskunde C',
    file: 'WC.svg',
    cssVarDark: 'color-subject-wc-dark',
    cssVarLight: 'color-subject-wc-light',
    bottomOffset: 19,
  },
  {
    name: 'Wiskunde',
    file: 'WI.svg',
    cssVarDark: 'color-subject-wi-dark',
    cssVarLight: 'color-subject-wi-light',
    bottomOffset: 15,
  },
  {
    name: 'Spaans',
    file: 'spaans.svg',
    cssVarDark: 'color-subject-spaans-dark',
    cssVarLight: 'color-subject-spaans-light',
    bottomOffset: 22,
  },
  {
    name: 'Lyceo Leren Leren',
    file: 'leren-leren.svg',
    cssVarDark: 'color-subject-leren-leren-dark',
    cssVarLight: 'color-subject-leren-leren-light',
    bottomOffset: 21,
  },
  {
    name: 'WST',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Specialisatie - Onderwijshelden PO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Specialisatie - Onderwijshelden VO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Specialisatie - Opstap PO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Specialisatie - Opstap VO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: "Trainingsprogramma VC's Lyceo Academy",
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'PO - dienst-specifiek',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'VO - dienst-specifiek',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Basisschool en de leerling',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Basisschoolbegeleiding',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'CodeLab',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Examentraining',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Faalangstvrijtraject',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Hwb en Bijles',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Opstap PO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'VO - Onderwijshelden',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Opstap VO',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Studiekeuzedag',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Wiskunde A-specialisatie',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Vmbo-specialisatie',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'V1 - Goed van start',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'V2 - Een sterke basis',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'V3 - Jouw volgende stap',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Startmodule',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'AV1 - Goed van start',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'AV2 - Een sterke basis',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'AV3 - Jouw volgende stap',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Lyceo Academie Klantenservice – Vaardigheden 1 – Goed van start',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Lyceo Academie VM - Vaardigheden 1 - Goed van start',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Lyceo Academie VM - Vaardigheden 2 – Een sterke basis',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'WSV1 - Goed van start',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'WSV2 - Een sterke basis',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'WSV3 - Jouw volgende stap',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Klantenservice',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Onderwijsheldenteam',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Online intaketeam',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Outbound belteam',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Roosterteam',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Studiecoaching',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
  {
    name: 'Vakantieschool',
    file: 'academie.svg',
    cssVarDark: 'color-subject-academy1-dark',
    cssVarLight: 'color-subject-academy1-light',
    bottomOffset: 22,
  },
];

export function findSubjectIcon(
  subjectName: string | undefined,
): LyceoSubjectIcon {
  return (
    lyceoSubjectIcons.find((icon) => icon.name === subjectName) ?? {
      name: subjectName ?? 'Onbekend',
      cssVarDark: 'background-basic-color-1',
      cssVarLight: 'background-basic-color-2',
      bottomOffset: 0,
    }
  );
}
